import Colors from '@/constants/Colors';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import styled from 'styled-components';

export const StyledAnswerWithFeedback = styled.div`
  flex: 2;
  display: grid;
  grid-template-rows: 1fr 1fr;

  .answer-with-feedback {
    display: flex;
    flex-direction: column;
    gap: 5px;
    position: relative;
    overflow: hidden;
    border: 1px dashed ${Colors.border};
    background: white;
    color: ${Colors.lighterGray};
    padding: 8px;

    span {
      color: ${Colors.text};
    }
  }
  .label {
    font-weight: ${font.weightBold};
  }
  .img-container {
    border-radius: 8px;
    overflow: hidden;

    .img-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: relative;

      &.success .anticon {
        color: ${Colors.success};
      }

      &.error .anticon {
        color: ${Colors.error};
      }

      .absolute-centered {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }
  }
  .correct-answer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border: 1px dashed ${Colors.border};
    border-top: none;
    background: white;
    padding: 8px;
  }
`;
